import { push } from "connected-react-router";

export function navigate(to, langDependent = true) {
  return function(dispatch, getState) {
    const locale = getState().i18n.locale;
    if (langDependent) {
      dispatch(push(`/${locale}${to}`));
    } else {
      dispatch(push(to));
    }
  };
}
